<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2022. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->

<template>
  <v-btn
    :id="`${id}`"
    :color="typeOfBtn === 'action' ? 'tttech-blue-button-active' : 'tttech-blue-button-cancel'"
    :disabled="disabled"
    :class="[{ 'normal-btn': size === 'normal' }, { 'small-btn': size === 'small' }]"
    class="nerve-btn"
    autofocus
    depressed
    @click="buttonClick"
  >
    {{ text }}
  </v-btn>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
    typeOfBtn: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    buttonClick() {
      this.$emit('click-event');
    },
  },
};
</script>
<style lang="scss" scoped>
.nerve-btn {
  max-width: 200px;
  text-transform: unset;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.normal-btn.v-size--default {
  height: auto !important;
  padding: 10px 16px !important;
}

.small-btn.v-size--default {
  height: auto !important;
  padding: 7px 12px !important;
}

.tttech-background-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: rgba(0, 0, 0, 0.12);
}

.tttech-blue-button-active {
  color: var(--v-secondary-base) !important;
  background-color: var(--v-primary-base) !important;
}

.tttech-blue-button-active:hover {
  background-color: var(--v-hoverPrimary-base) !important;
}
.tttech-blue-button-cancel {
  color: var(--v-secondary-base) !important;
  background-color: var(--v-tertiaryBtn-base) !important;
}

.tttech-blue-button-cancel:hover {
  background-color: var(--v-hoverSecondary-base) !important;
}
</style>
